import {call, put, select} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {commentsListCurrentPage, commentsListFetchData} from "features/components/comment-box/selectors";
import {getCommentsFailure, getCommentsSuccess} from "features/components/comment-box/reducer";

export function* commentsListSaga() {
    const {type, id, order_by} = yield select(commentsListFetchData);
    const page = yield select(commentsListCurrentPage);
    try {
        const data = yield call([api, api.getCommentsApi], type, id, page, order_by);
        yield put(getCommentsSuccess(data));
    } catch (e) {
        console.log(e);
        yield put(getCommentsFailure(getErrorFromMessage(e)));
    }
}